var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEtAtiviAtivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8295 32.4879C31.8295 32.7707 32.0588 33 32.3416 33H34.7676C35.0504 33 35.2797 32.7707 35.2797 32.4879V28.3997H36.8265C37.2828 28.3997 37.5112 27.8482 37.1886 27.5256L33.9167 24.2536C33.7167 24.0536 33.3925 24.0536 33.1925 24.2536L29.9205 27.5256C29.5979 27.8482 29.8264 28.3997 30.2827 28.3997H31.8295V32.4879Z",
    fill: "#4D78AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0917 13.2646C21.9071 13.0945 21.6651 13 21.414 13H13.1609C11.9724 13 11.0108 13.8961 11.0108 14.9914L11 30.923C11 32.0183 11.9616 32.9144 13.1501 32.9144H26.1264C27.3149 32.9144 28.2873 32.0183 28.2873 30.923V19.4126C28.2873 19.1333 28.1704 18.8666 27.9649 18.6773L22.0917 13.2646ZM20.9741 19.9701C20.836 19.9701 20.7241 19.8581 20.7241 19.7201V15.0639C20.7241 14.8461 20.9833 14.7325 21.1435 14.8801L26.1958 19.5362C26.3633 19.6905 26.2541 19.9701 26.0264 19.9701H20.9741Z",
    fill: "#4D78AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEtAtiviAtivo);
export default __webpack_public_path__ + "static/media/IconEtAtiviAtivo.6b4b8be6b1091cc1b9d958e485795e9f.svg";
export { ForwardRef as ReactComponent };